import { useAuth as e, useMeQuery as t } from "@maat/store-auth";
import { VerificationStatus as n } from "@maat/api-main/types";
//#region src/verification/useIdentityBookingGate.ts
var r = () => {
	let { isAuthenticated: r } = e(), { data: i, isError: a } = t(r), o = i?.identity_gate;
	return {
		shouldPrompt: o?.blocks_booking === !0,
		status: o?.status ?? n.Unverified,
		resolved: !r || i !== void 0 || a
	};
};
//#endregion
export { r as useIdentityBookingGate };
